import React from 'react'

import { ApiContext } from '@/providers/ApiProvider'
import { apiService } from '@/providers/apiService'

const useApi = () => {
  const apiContext = React.useContext(ApiContext)
  const { api, uid } = apiContext || {}

  // Fall back to the module-level singleton when context is lost (e.g. during HMR)
  return { api: api ?? apiService, uid }
}

export default useApi
